/* eslint-disable react/button-has-type */
import classNames from 'classnames';
import React from 'react';

type ButtonProps = {
  disableBorders?: boolean;
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const Button: React.FC<ButtonProps> = ({
  className,
  type = 'button',
  children,
  disableBorders = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      className={classNames(
        'px-4 py-2 text-xs font-semibold tracking-wider focus:outline-none focus:ring-1 focus:ring-gray-300 hover:bg-ffocusbackground text-gray-600',
        !disableBorders ? 'border border-gray-300 rounded' : '',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};
export default Button;
